import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { GroupBoxWrapper, GroupBoxContent } from './components/blocks.js';
import { DSGroupBoxHeader } from './components/GroupHeader.js';
import { BOX_TYPES_ARRAY, BOX_TYPES } from './constants.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-truncated-tooltip-text';
import './Actions.js';
import 'prop-types';
import 'styled-components';
import 'styled-system';
import '@elliemae/ds-system';
import './ActionItem.js';
import './LabelElement.js';
import './GroupBoxLabel.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DSGroupBox = function DSGroupBox(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {
    labelText: '',
    borderBottom: false,
    id: 'ds-group-box__header'
  } : _ref$labelProps,
      _ref$rightActions = _ref.rightActions,
      rightActions = _ref$rightActions === void 0 ? [] : _ref$rightActions,
      _ref$centerActions = _ref.centerActions,
      centerActions = _ref$centerActions === void 0 ? [] : _ref$centerActions,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? BOX_TYPES.CATEGORY : _ref$type,
      _ref$asRow = _ref.asRow,
      asRow = _ref$asRow === void 0 ? false : _ref$asRow,
      _ref$onlyHeader = _ref.onlyHeader,
      onlyHeader = _ref$onlyHeader === void 0 ? false : _ref$onlyHeader,
      _ref$noBorder = _ref.noBorder,
      noBorder = _ref$noBorder === void 0 ? true : _ref$noBorder,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$children = _ref.children,
      components = _ref$children === void 0 ? [] : _ref$children,
      _ref$isMain = _ref.isMain,
      isMain = _ref$isMain === void 0 ? true : _ref$isMain;
  var labelText = labelProps.labelText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupBoxWrapper, _extends({}, containerProps, {
    classProps: {
      onlyHeader: onlyHeader,
      noBorder: noBorder,
      type: type,
      isMain: isMain
    }
  }), labelText && /*#__PURE__*/React.createElement(DSGroupBoxHeader, {
    centerActions: centerActions,
    isMain: isMain,
    labelProps: labelProps,
    noBorder: noBorder,
    rightActions: rightActions,
    type: type
  }), /*#__PURE__*/React.createElement(GroupBoxContent, {
    classProps: {
      type: type,
      asRow: asRow,
      onlyHeader: onlyHeader,
      noPadding: noPadding,
      noBorder: noBorder,
      noBorderTop: !!labelText
    }
  }, components && components.props ? React.Children.map(components, function (component) {
    return /*#__PURE__*/React.cloneElement(component, _objectSpread(_objectSpread({}, component.props), {}, {
      isMain: false
    }));
  }, null) : components)));
};

var props = {
  /** props to inject to wrapper */
  containerProps: PropTypes.object.description('props to inject to wrapper'),

  /**
   * Label attributes to be rendered
   */
  labelProps: PropTypes.shape({
    labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    borderBottom: PropTypes.bool,
    id: PropTypes.string
  }).description('Label attributes to be rendered'),

  /**
   * ['category-box', 'group-box']
   */
  type: PropTypes.oneOf(BOX_TYPES_ARRAY).description(BOX_TYPES_ARRAY.toString()),

  /**
   * Components to be rendered inside the box
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired.description('Components to be rendered inside the box'),

  /**
   * Actions on the right side of the label
   */
  rightActions: PropTypes.arrayOf(PropTypes.element).description('Actions on the right side of the label'),

  /**
   * Actions on the next to the label
   */
  centerActions: PropTypes.arrayOf(PropTypes.element).description('Actions on the next to the label'),

  /**
   * Display the content of the group box with flex direction row
   */
  asRow: PropTypes.bool.description('Display the content of the group box with flex direction row'),

  /**
   * Show border only on the header
   */
  onlyHeader: PropTypes.bool.description('Show border only on the header'),

  /**
   * Remove the wrapper border
   */
  noBorder: PropTypes.bool.description('Remove the wrapper border'),

  /**
   * Remove the top and bottom padding from the content
   */
  noPadding: PropTypes.bool.description('Remove the top and bottom padding from the content')
};
DSGroupBox.propTypes = props;
var DSGroupBoxWithSchema = describe(DSGroupBox);
DSGroupBoxWithSchema.propTypes = props;

export default DSGroupBox;
export { DSGroupBox, DSGroupBoxWithSchema };
//# sourceMappingURL=DSGroupBox.js.map
